import { toast } from 'react-toastify';

const showSuccess = (message) => {
  toast.success(message, {
    containerId: 'global-toast',
    toastId: 'save-success',
  });
};

export default showSuccess;
